/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';

@Injectable()
export class NeverActivateRouting  {

    canActivate(
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot
    ): Observable<boolean>|Promise<boolean>|boolean {
        return false; // never allow activation
    }
}
